import {
  GET_DEMAND_DETAILS,
  GET_USER_DETAILS,
  GET_TRANSACTIONS,
  GET_DEMAND_CONFIG,
  CLEAR_FREIGHT_NAME,
  UPLOAD_FREIGHT,
  UPDATE_DEMAND_DETAILS,
  UPDATE_FREIGHT_DETAILS,
  GET_EXPENSE_DETAILS,
  GET_REMARKS,
  GET_EXPENSE_TYPES,
  GET_EMAILS_LIST,
  ADD_EXPENSE,
  EDIT_EXPENSE,
  DELETE_EXPENSE,
  CREATE_TRANSACTION,
  EDIT_TRANSACTION,
  ASSIGN_INDENT,
  SETTLE_EXPENSE,
  GET_CONSIGNERS,
  GET_MATERIAL_DETAILS,
  GET_MATERIAL_TYPES,
  CREATE_MATERIAL_DETAILS,
  GET_DEMAND_VEHICLES,
  GET_PTL_DETAILS,
  UPDATE_PTL_METADATA_DETAILS,
  GET_GST_DETAILS,
} from './actions';
import { FAILURE, REQUEST, SUCCESS } from 'utils/actionGenerator';
import _get from 'lodash/get';

const defaultState = {};

export default function (state = defaultState, action) {
  switch (action.type) {
    // case GET_DEMAND_DETAILS[REQUEST]:
    //   return { ...state, demandDetails: {} };
    case GET_DEMAND_DETAILS[SUCCESS]:
      return { ...state, demandDetails: action.response.data };
    case GET_EXPENSE_DETAILS[SUCCESS]:
      return { ...state, expenses: action.response.data };

    case GET_CONSIGNERS[SUCCESS]:
      return { ...state, consignerList: action.response.data };
    // case GET_USER_DETAILS[REQUEST]:
    //   return { ...state, userDetails: {} };
    case GET_USER_DETAILS[SUCCESS]:
      return { ...state, userDetails: action.response.data };
    // case GET_TRANSACTIONS[REQUEST]:
    //   return { ...state, transactions: [] };
    case GET_TRANSACTIONS[SUCCESS]:
      return { ...state, transactions: action.response.data.transactions };
    case GET_REMARKS[SUCCESS]:
      return { ...state, remarks: action.response.data };
    case GET_EMAILS_LIST[SUCCESS]: {
      if ((action?.params?.params?.type ?? '') === 'CREATED_BY') {
        return { ...state, createdByEmailsList: action.response.data.users };
      } else {
        return { ...state, assignedToEmailsList: action.response.data.users };
      }
    }
    // case GET_DEMAND_CONFIG[REQUEST]:
    //   return { ...state, config: {} };
    case GET_DEMAND_CONFIG[SUCCESS]:
      return { ...state, config: action.response.data };

    case GET_DEMAND_VEHICLES[REQUEST]:
      return { ...state, vehiclesList: [], isFetchingVehiclesList: true };
    case GET_DEMAND_VEHICLES[SUCCESS]:
      return { ...state, vehiclesList: action.response.data?.vehicles ?? [], isFetchingVehiclesList: false };
    case GET_DEMAND_VEHICLES[FAILURE]:
      return {
        ...state,
        vehiclesList: [],
        isFetchingVehiclesList: false,
      };
    case CLEAR_FREIGHT_NAME:
      return { ...state, freightDisplayName: '' };
    case UPLOAD_FREIGHT[REQUEST]:
      return { ...state, freightFileName: '', freightUploaded: false };
    case UPLOAD_FREIGHT[SUCCESS]:
      return {
        ...state,
        freightFileName: action.response,
        freightUploaded: true,
      };
    case UPDATE_DEMAND_DETAILS[REQUEST]:
      return { ...state, basicDetailsUpdated: false };
    case UPDATE_DEMAND_DETAILS[SUCCESS]:
      return { ...state, basicDetailsUpdated: true };
    case UPDATE_PTL_METADATA_DETAILS[REQUEST]:
      return { ...state, ptlMetadataDetailsUpdated: false };
    case UPDATE_PTL_METADATA_DETAILS[SUCCESS]:
      return { ...state, ptlMetadataDetailsUpdated: true };
    // expenseSubmitting is true while an add/edit is in flight, so the popover can refuse a second
    // submit - a double click on a coupon reversal would otherwise write two debit notes.
    case ADD_EXPENSE[REQUEST]:
      return { ...state, expenseAdded: false, expenseSubmitting: true };
    case ADD_EXPENSE[SUCCESS]:
      return { ...state, expenseAdded: true, expenseSubmitting: false };
    case ADD_EXPENSE[FAILURE]:
      return { ...state, expenseSubmitting: false };
    case EDIT_EXPENSE[REQUEST]:
      return { ...state, expenseEdited: false, expenseSubmitting: true };
    case EDIT_EXPENSE[SUCCESS]:
      return { ...state, expenseEdited: true, expenseSubmitting: false };
    case EDIT_EXPENSE[FAILURE]:
      return { ...state, expenseSubmitting: false };
    case DELETE_EXPENSE[REQUEST]:
      return { ...state, expenseDeleted: false };
    case DELETE_EXPENSE[SUCCESS]:
      return { ...state, expenseDeleted: true };
    case UPDATE_FREIGHT_DETAILS[REQUEST]:
      return { ...state, freightDetailsUpdated: false };
    case UPDATE_FREIGHT_DETAILS[SUCCESS]:
      return { ...state, freightDetailsUpdated: true };
    case CREATE_TRANSACTION[REQUEST]:
      return { ...state, transactionCreated: false };
    case CREATE_TRANSACTION[SUCCESS]:
      return { ...state, transactionCreated: true };
    case EDIT_TRANSACTION[REQUEST]:
      return { ...state, transactionEdited: false };
    case EDIT_TRANSACTION[SUCCESS]:
      return { ...state, transactionEdited: true };
    case ASSIGN_INDENT[REQUEST]:
      return { ...state, indentAssigned: false };
    case ASSIGN_INDENT[SUCCESS]:
      return { ...state, indentAssigned: true };
    case SETTLE_EXPENSE[REQUEST]:
      return { ...state, expenseSettled: false };
    case SETTLE_EXPENSE[SUCCESS]:
      return { ...state, expenseSettled: true };
    case GET_EXPENSE_TYPES[SUCCESS]: {
      // Support both: response = { data: { expenseType, dependantFields } } and response = { expenseType, dependantFields }
      const data = action.response?.data ?? action.response;
      const isV3Shape =
        data &&
        typeof data === 'object' &&
        !Array.isArray(data) &&
        Array.isArray(data.expenseType);
      const expenseTypes = isV3Shape
        ? data.expenseType.map((et) => ({
            expenseCategory: et,
            fields:
              Array.isArray(data.dependantFields) &&
              data.dependantFields.find((d) => d.expenseType === et)?.fields,
          }))
        : (Array.isArray(data) ? data : []);
      return {
        ...state,
        expenseTypes,
      };
    }
    case GET_MATERIAL_DETAILS[REQUEST]:
      return { ...state, materialDetails: null, materialImages: [] };
    case GET_MATERIAL_DETAILS[SUCCESS]:
      return {
        ...state,
        materialDetails: action.response.materials,
        materialImages: action.response.materialImages ?? [],
      };
    case GET_MATERIAL_TYPES[REQUEST]:
      return { ...state, materialTypes: null };
    case GET_MATERIAL_TYPES[SUCCESS]:
      return { ...state, materialTypes: action.response };
    case CREATE_MATERIAL_DETAILS[REQUEST]:
      return { ...state, materialDetailsUpdated: null };
    case CREATE_MATERIAL_DETAILS[SUCCESS]:
      return { ...state, materialDetailsUpdated: true };
    case GET_PTL_DETAILS[REQUEST]:
      return { ...state, ptlMetaData: null };
    case GET_PTL_DETAILS[SUCCESS]:
      return { ...state, ptlMetaData: action.response.data };
    case GET_GST_DETAILS[REQUEST]:
      return { ...state, gstDetails: null };
    case GET_GST_DETAILS[SUCCESS]:
      return { ...state, gstDetails: action.response };
    case GET_GST_DETAILS[FAILURE]:
      return { ...state, gstDetails: null };
    default:
      return state;
  }
}

// export const getDemandTabReducer = (state) => state.demandTab;

export const getBasicDetails = (state) => _get(state, 'placement.demandTab.demandDetails', {});
export const getConsignerList = (state) => _get(state, 'placement.demandTab.consignerList', []);
export const getExpenses = (state) => _get(state, 'placement.demandTab.expenses', {});

/** UI expects array of { expenseCategory }. Normalize v3 shape { expenseType, dependantFields } at read time if needed. */
export const getExpenseTypes = (state) => {
  const raw = _get(state, 'placement.demandTab.expenseTypes', []);
  if (Array.isArray(raw)) return raw;
  const data = raw && typeof raw === 'object' && Array.isArray(raw.expenseType) ? raw : null;
  if (!data) return [];
  return data.expenseType.map((et) => ({
    expenseCategory: et,
    fields: Array.isArray(data.dependantFields) && data.dependantFields.find((d) => d.expenseType === et)?.fields,
  }));
};
export const getRemarks = (state) => _get(state, 'placement.demandTab.remarks', {});

export const getCreatedByEmailsList = (state) => _get(state, 'placement.demandTab.createdByEmailsList', {});
export const getAssignedToEmailsList = (state) => _get(state, 'placement.demandTab.assignedToEmailsList', {});

export const getUserDetails = (state) => _get(state, 'placement.demandTab.userDetails', {});
export const getTransactions = (state) => _get(state, 'placement.demandTab.transactions', {});
export const getDemandConfig = (state) => _get(state, 'placement.demandTab.config', {});
export const getFreightFileName = (state) => _get(state, 'placement.demandTab.freightFileName', '');
export const getFreightDisplayName = (state) => _get(state, 'placement.demandTab.freightDisplayName', '');
export const getBasicDetailsUpdateFlag = (state) => _get(state, 'placement.demandTab.basicDetailsUpdated', false);
export const getPtlMetadataUpdateUpdateFlag = (state) =>
  _get(state, 'placement.demandTab.ptlMetadataDetailsUpdated', false);
export const getFreightDetailsUpdateFlag = (state) => _get(state, 'placement.demandTab.freightDetailsUpdated', false);
export const getAddExpenseFlag = (state) => _get(state, 'placement.demandTab.expenseAdded', false);
export const getEditExpenseFlag = (state) => _get(state, 'placement.demandTab.expenseEdited', false);
export const getExpenseSubmittingFlag = (state) => _get(state, 'placement.demandTab.expenseSubmitting', false);
export const getDeleteExpenseFlag = (state) => _get(state, 'placement.demandTab.expenseDeleted', false);
export const getFreightUploadedFlag = (state) => _get(state, 'placement.demandTab.freightUploaded', false);
export const getCreateTransactionFlag = (state) => _get(state, 'placement.demandTab.transactionCreated', false);
export const getEditTransactionFlag = (state) => _get(state, 'placement.demandTab.transactionEdited', false);
export const getAssignIndentFlag = (state) => _get(state, 'placement.demandTab.indentAssigned', false);
export const getSettleExpenseFlag = (state) => _get(state, 'placement.demandTab.expenseSettled', false);
export const getMaterialDetails = (state) => _get(state, 'placement.demandTab.materialDetails', false);
export const getMaterialImages = (state) => _get(state, 'placement.demandTab.materialImages', []);
export const getMaterialTypes = (state) => _get(state, 'placement.demandTab.materialTypes', false);
export const getMaterialDetailsUpdated = (state) => _get(state, 'placement.demandTab.materialDetailsUpdated', false);
export const getDemandVehiclesState = (state) => _get(state, 'placement.demandTab.vehiclesList', []);
export const getPtlDetails = (state) => _get(state, 'placement.demandTab.ptlMetaData', {});
// export const getPtlDetailsUpdateFlag = (state) => _get(state, 'placement.demandTab.ptlMetaData', {});
export const getGstDetails = (state) => _get(state, 'placement.demandTab.gstDetails', null);
